/* tslint:disable */
/* eslint-disable */
/**
 * BackendFramework
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Role } from "./role";

/**
 *
 * @export
 * @interface UserProjectInfo
 */
export interface UserProjectInfo {
  /**
   *
   * @type {string}
   * @memberof UserProjectInfo
   */
  projectId: string;
  /**
   *
   * @type {boolean}
   * @memberof UserProjectInfo
   */
  projectIsActive: boolean;
  /**
   *
   * @type {string}
   * @memberof UserProjectInfo
   */
  projectName: string;
  /**
   *
   * @type {string}
   * @memberof UserProjectInfo
   */
  projectVernacular: string;
  /**
   *
   * @type {Role}
   * @memberof UserProjectInfo
   */
  role: Role;
}
